module.exports = __webpack_public_path__ + "static/media/UserBannerAppScreenshot.0fdeb0b8.png";